define('modules/form_editor/views/preview_custom_privacy',['require','exports','module','./preview_group_base','./preview_check_item','lib/markdown','../../editor/models/editorstate','ldsh!../templates/custom_privacy'],function(require,exports,module){
  "use strict";

  var InputGroupBase = require('./preview_group_base'),
      CheckItemView = require('./preview_check_item'),
      markdown = require('lib/markdown'),
      EditorState = require('../../editor/models/editorstate');

  module.exports = InputGroupBase.extend({
    template: require('ldsh!../templates/custom_privacy'),
    itemView: CheckItemView,
    itemViewClassName: 'checkbox-terms checkbox-block',

    helpers: function(){
      var templateParams = {
        nameAttr: this.getNameHtml(),
        alignLeft: this.collection.length === 1,
        isAMP: EditorState.getAMPState(),
        ampStateId: this.model.get('ampStateId'),
        informationTextParsed: markdown(this.model.get('informationText'))
      };

      return templateParams;
    },

    getNameHtml: function(){
      var name = this.model.get('nameAttr');

      if (name) {
        return name;
      }

      var label = this.model.get('labelText');

      if (isNaN(label.slice(-1))) {
        return 'checkbox' + 0;
      }

      return 'checkbox' + label.slice(-1);
    }
  });
});

